import React from 'react';

const ProductAddonSetTitle = ({ record }) => {
	return <span>ProductAddonSet {record ? `"${record.name}"` : ''}</span>;
};

export default ProductAddonSetTitle;
